import { render, staticRenderFns } from "./transactionmodal.vue?vue&type=template&id=22ccace8"
import script from "./transactionmodal.vue?vue&type=script&lang=js"
export * from "./transactionmodal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports